module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-cjdr.ffb1bc3a.png";